export const SUPPORT_CATEGORIES = [
	{ value: 'account', label: 'Account' },
	{ value: 'billing', label: 'Billing & Invoices' },
	{ value: 'campaigns', label: 'Email campaigns & Settings' },
	{ value: 'companySettings', label: 'Company Settings' },
	{ value: 'customDevelopment', label: 'Custom Development Work' },
	{ value: 'customIntegration', label: 'Custom Integration' },
	{ value: 'customRequests', label: 'Custom Requests' },
	{ value: 'emailBuilder', label: 'Email Builder' },
	{ value: 'templates', label: 'Email Templates' },
	{ value: 'general', label: 'General' },
	{ value: 'payments', label: 'Payments & Subscriptions' },
	{ value: 'technical', label: 'Technical issue' },
	{ value: 'website', label: 'Website Authentication' },
	{ value: 'other', label: 'Other' },
];

export const SUPPORT_CATEGORY_VALUES = SUPPORT_CATEGORIES.map((c) => c.value);
